import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { responsiveFontSizes } from "@mui/material";
import Home from "./Component/Home/Home";
import Profile from "./Component/Profile/Profile";
import Post from "./Component/Post/Post";

// 페이지 컴포넌트 import

function App() {
  return (
    <Router>
      <Routes>
        {/* 메인 페이지 */}
        <Route path="/" element={<Home />} />

        {/* 프로필 페이지 - URL Params 사용 */}
        {/* 예시: /profile/123 */}
        <Route path="/profile/:id" element={<Profile />} />

        {/* 설정 페이지 */}
        <Route path="/Post/:postType/:id" element={<Post />} />
      </Routes>
    </Router>
  );
}

export default App;
